import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  DialogActions,
  Button,
} from "@mui/material";
import { baseUrl } from "../../../../../../../../network/constants/constants";
import "./viewPage.css";

const ViewPageCategory = ({
  open,
  onClose,
  currentRequest,
  newRequest,
  status,
  currentId,
  handleAdminResponse,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: "20px" },
      }}
    >
      <DialogTitle className="request-head">Request Details</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Typography variant="h6">
            Status: <span className="status-span">{status}</span>
          </Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="request-subhead">Field</TableCell>
                <TableCell className="request-subhead">Old Value</TableCell>
                <TableCell className="request-subhead">Edited Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className="subhead">Category Name</TableCell>
                <TableCell>
                  {currentRequest?.categoryName || <Typography>N/A</Typography>}
                </TableCell>
                <TableCell>
                  {newRequest?.categoryName || <Typography>N/A</Typography>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="subhead">Category Icon</TableCell>
                <TableCell>
                  {currentRequest?.icon ? (
                    <img
                      src={`${baseUrl}${currentRequest?.icon}`}
                      alt="Current Icon"
                      style={{ width: 50, height: 50, objectFit: "contain" }}
                    />
                  ) : (
                    <Typography color="textSecondary">N/A</Typography>
                  )}
                </TableCell>
                <TableCell>
                  {newRequest?.icon ? (
                    <img
                      src={`${baseUrl}${newRequest?.icon}`}
                      alt="New Icon"
                      style={{ width: 50, height: 50, objectFit: "contain" }}
                    />
                  ) : (
                    <Typography color="textSecondary">N/A</Typography>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <DialogActions>
          <Button
            onClick={onClose}
            variant="contained"
            color="error"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          {status === "Pending" && (
            <>
          <Button
            variant="outlined"
            color="success"
            style={{ marginRight: "5px" }}
            onClick={() => {
              handleAdminResponse(currentId, "accept");
              onClose();
            }}
          >
            Accept
          </Button>
          <Button
            variant="outlined"
            color="error"
            style={{ marginRight: "5px" }}
            onClick={() => {
              handleAdminResponse(currentId, "reject");
              onClose();
            }}
          
          >
            Reject
          </Button>
          </>
          )}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ViewPageCategory;
